import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { GeneralService } from './shared/services/general.service';
import { AppInitService } from './shared/services/app-init.service';
import { AuthService } from './core/services/auth/auth.service';
import { MenuService } from './shared/services/menu.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private router: Router,
      private _appInitService : AppInitService,
      private _authService : AuthService,
      private _menuService : MenuService
  ) { }

  ngOnInit() {
    this.initApp();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  initApp() {
    this._appInitService.init().then(() => {
      this._authService.isLogin().then( isLogin =>{
        if (isLogin){
          this._menuService.build_menu()
        }
      })});
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts